import { useState, useEffect } from 'react';
import Navbar from '../components/Navbar';
import Filters from '../components/Filters';
import axios from 'axios';
import { BACKEND_URL } from "../data/config";

const AbsentsPage = () => {
  const [absents, setAbsents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({ month: '' });

  const loadData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${BACKEND_URL}/api/top-absents.php?month=${filters.month}`);
      setAbsents(response.data.data);
    } catch (error) {
      console.error('Erreur:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const currentMonth = new Date().toISOString().slice(0, 7);
    setFilters({ month: currentMonth });
  }, []);

  useEffect(() => {
    if (filters.month) loadData();
  }, [filters.month]);

  const handleFilterChange = (month) => {
    setFilters({ month });
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50">
        <Navbar />
        <div className="max-w-7xl mx-auto p-8">
          <div className="animate-pulse bg-white rounded-2xl p-12">
            <div className="h-8 bg-gray-200 rounded-lg w-1/3 mx-auto mb-12"></div>
            <div className="space-y-4 max-w-2xl mx-auto">
              {[...Array(10)].map((_, i) => (
                <div key={i} className="h-16 bg-gray-200 rounded-xl"></div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <div className="max-w-7xl mx-auto p-8">
        <div className="mb-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Employés Absents</h1>
          <p className="text-xl text-gray-600">Mois sélectionné : {filters.month || 'Chargement...'}</p>
        </div>

        <Filters onFilterChange={handleFilterChange} />

        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Rang</th>
                  <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Employé</th>
                  <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Jours d'absence</th>
                  <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Dates</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {absents.length ? (
                  absents.map((absent, index) => (
                    <tr key={index} className="hover:bg-gray-50">
                      <td className="px-6 py-4 whitespace-nowrap">
                        <span className="w-8 h-8 bg-gray-200 text-gray-800 rounded-full flex items-center justify-center text-sm font-bold">
                          {index + 1}
                        </span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap font-semibold text-gray-900">{absent.name}</td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <span className="px-3 py-1 bg-red-100 text-red-800 text-sm font-semibold rounded-full">
                          {absent.absent_days} jours
                        </span>
                      </td>
                      <td className="px-6 py-4 text-sm text-gray-600">{new Date(absent.date).toLocaleDateString()}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={4} className="px-6 py-12 text-center text-gray-500">
                      Aucun absent ce mois-ci 🎉
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AbsentsPage;
